"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// default pick & drop time during initial app load
// and when branch is not selected
exports.default = '09:00 AM';
